import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { HistoryLayout } from '../../../../common/history/history-layout.component';
import { TablePagination } from '../../../../common/details-table/table-pagination.component';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { planCatalogueHistoryActions } from "../../../../../store/external/finance/history/plan-catalogue-history.reducer";
import { Loading } from '../../../../common/loading';
import { MODAL_CUSTOM_MESSAGE } from "../../../../../constants/external-constants";

class PlanCatalogueHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            enableSearchBox: false,
            isLoading: true,
            exportAlertMsg: MODAL_CUSTOM_MESSAGE.export_alert_message,
        }
    }

    componentDidMount() {
        const { getPlanCatalogueHistoryLogs, planId } = this.props;

        getPlanCatalogueHistoryLogs(planId)
            .then(() => {
                this.setState({ isLoading: false })
            });
    }

    componentWillUnmount() {
        this.props.resetPlanCatalogueHistory();
    }

    getTableData(pageIndex) {
        this.props.getPlanCatalogueHistoryLogs(this.props.planId, pageIndex);
    }

    resizePage = (pageSize) => {
        const { resizePlanCatalogueHistoryLogs, getPlanCatalogueHistoryLogs, planId } = this.props;
        resizePlanCatalogueHistoryLogs(pageSize)
        
        this.setState({ isLoading: true });

        getPlanCatalogueHistoryLogs(planId)
            .then(() => {
                this.setState({ isLoading: false })
            });
    }

    financePlanPaginationAction = (pageIndex) => {
        const { getPlanCatalogueHistoryLogs, planId } = this.props;
        
        this.setState({ isLoading: true });

        getPlanCatalogueHistoryLogs(planId, pageIndex)
            .then(() => {
                this.setState({ isLoading: false })
            });
    }

    onColumnSearch = () => {
        const { getPlanCatalogueHistoryLogs, planId } = this.props;
        
        getPlanCatalogueHistoryLogs(planId, 0);
    }

    displaySearchBox = (value) => {
        this.setState({ enableSearchBox: value })
    }

    onClickExtract = () => {
        const { planId, extractPlanCatalogueHistoryLogs } = this.props;
        if (window.confirm(this.state.exportAlertMsg)) {
            extractPlanCatalogueHistoryLogs(planId);
        }
    }  

    render() {
        const { setPlanCatalogueColSearchStr, isReadOnly, isReadAndExtractOnly, isReadAndWrite } = this.props;
        const { Headers, Data, Pagination } = this.props.planCatalogueHistory.HistoryTable;
        if (this.state.isLoading) {
           return <Loading />
        }
        return (
            <div>
            <HistoryLayout
             displaySearchBox={this.displaySearchBox}
             extractAction={this.onClickExtract}
            //Access Type
            isReadOnly={isReadOnly}
            isReadAndExtractOnly={isReadAndExtractOnly}
            isReadAndWrite={isReadAndWrite} 
            hideCustomColumn={true}
            >
                <TablePagination
                    key="table-pagination-key"
                    columns={Headers}
                    pageList={Data}                 
                    pages={Pagination}
                    paginationAction={this.financePlanPaginationAction}
                    onColumnSearch={() => { this.onColumnSearch() }}
                    onColumnSearchChange={setPlanCatalogueColSearchStr}
                    isColSearchShow={this.state.enableSearchBox}
                    resizePage={this.resizePage}
                    totalPage={Pagination.TotalEntries}
                    isNotSortable={true}
                    isLoading={this.state.isLoading}   
                />
            </HistoryLayout>
        </div>
        );
    }
}

export default connect(
    state => {
        const { planCatalogueHistory } = state;

        return {
            planCatalogueHistory
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, planCatalogueHistoryActions),
        dispatch
    )
)(PlanCatalogueHistory);